// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBylines_root__NaEL5","link":"ArticleBylines_link__3bVCl"};